import React from 'react'

export const TextType = ({ item }) => <p className='mb-0 mt-2'>{item.value.value[0] || null}</p>
